import React from 'react';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { ServiceModeAddress } from './service-mode-address';
import { SubheaderContainer } from './styled';
import { SubheaderLanguageSelector } from './subheader-language-selector';
import { IServiceModeAddressProps } from './types';

const SubHeader: React.FC<IServiceModeAddressProps> = ({
  store,
  serviceMode,
  userAddress,
  cateringPickupDateTime
}) => {
  const hideServiceMode = useFlag(LaunchDarklyFlag.HIDE_SERVICE_MODE);
  const enableBottomService = useFlag(LaunchDarklyFlag.ENABLE_BOTTOM_SERVICE_MODE);

  if (enableBottomService) {
    return null;
  }
  return (
    <SubheaderContainer>
      {!hideServiceMode && (
        <ServiceModeAddress
          store={store}
          serviceMode={serviceMode}
          userAddress={userAddress}
          cateringPickupDateTime={cateringPickupDateTime}
        />
      )}
      <SubheaderLanguageSelector />
    </SubheaderContainer>
  );
};

export default SubHeader;
